import { Helmet } from "react-helmet-async"
import { TenantCreditStatsView } from "../../../../SubscriptionWalletCredits"

export default function AdminCreditConsumptionTenantsPage() {
	return (
		<>
			<Helmet>
				<title>Tenant-wise Credit Consumption</title>
			</Helmet>
			<TenantCreditStatsView />
		</>
	)
}
